/*خیابان*/
import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={79.574}
      height={96.663}
      viewBox="0 0 79.574 96.663"
      {...props}
    >
      <g data-name="Group 627" fill="#7f84ba">
        <path
          data-name="Path 11221"
          d="M29.354 10.95l10.431-9.062 10.431 9.062zm0 0"
        />
        <path
          data-name="Path 11222"
          d="M56.824 18.502L67.255 9.44l10.431 9.062zm0 0"
        />
        <path
          data-name="Path 11223"
          d="M1.888 18.502L12.319 9.44l10.431 9.062zm0 0"
        />
      </g>
      <path
        data-name="Path 11224"
        d="M38.369 10.95l3.21 13.593h2.707l3.209-13.593zm0 0"
        fill="#ffb954"
      />
      <path
        data-name="Path 11225"
        d="M65.589 18.502l3.21 13.593h2.958l3.207-13.593zm0 0"
        fill="#ffb954"
      />
      <path
        data-name="Path 11226"
        d="M19.969 18.754h-9.318l3.15 13.341h3.018zm0 0"
        fill="#ffb954"
      />
      <path
        data-name="Path 11227"
        d="M40.331 76.651l-4.28 18.125h14.013l-4.28-18.125zm0 0"
        fill="#7f84ba"
      />
      <path
        data-name="Path 11228"
        d="M36.009 32.095h7.552v44.556h-7.552zm0 0"
        fill="#7f84ba"
      />
      <path
        data-name="Path 11229"
        d="M36.009 32.095h7.552v44.556h-7.552zm0 0"
        fill="#b9b9ed"
      />
      <path
        data-name="Path 11230"
        d="M78.924 17.077L68.493 8.015a1.887 1.887 0 00-2.476 0l-10.431 9.062a1.888 1.888 0 001.238 3.313h1.228l2.866 12.139a1.888 1.888 0 001.838 1.454h2.611v3.776H45.449v-5.66a1.888 1.888 0 00-1.888-1.888h-1.888v-3.78h2.611a1.888 1.888 0 001.838-1.454l2.866-12.139h1.228a1.888 1.888 0 001.238-3.313L41.023.463a1.887 1.887 0 00-2.476 0L28.116 9.525a1.888 1.888 0 001.238 3.313h1.228l2.866 12.139a1.888 1.888 0 001.837 1.454H37.9v3.776h-1.891a1.888 1.888 0 00-1.888 1.892v5.66H14.207v-3.776h2.612a1.887 1.887 0 001.837-1.454l2.867-12.139h1.227a1.888 1.888 0 001.238-3.313L13.557 8.015a1.887 1.887 0 00-2.476 0L.65 17.077a1.888 1.888 0 001.238 3.313h1.228l2.866 12.139a1.888 1.888 0 001.838 1.454h2.611v5.664a1.888 1.888 0 001.888 1.888h21.8v9.064a1.888 1.888 0 103.776 0v-9.064h3.776v33.228H37.9v-9.064a1.888 1.888 0 10-3.776 0v9.062h-.336a1.888 1.888 0 00-1.838 1.454l-4.281 18.127a1.888 1.888 0 001.837 2.322h20.558a1.888 1.888 0 001.836-2.322l-4.278-18.125a1.888 1.888 0 00-1.838-1.454h-.336V41.535h21.807a1.888 1.888 0 001.888-1.888v-5.664h2.612a1.888 1.888 0 001.837-1.454l2.866-12.139h1.228a1.888 1.888 0 001.238-3.313zM39.785 4.389l5.379 4.673H34.406zm-5.323 8.449h10.647l-2.318 9.817H36.78zm-22.143-.9l5.381 4.676H6.94zM7 20.39h10.643l-2.318 9.817H9.314zm40.683 72.5H31.892l3.388-14.351h9.01zM37.9 37.759v-3.776h3.776v3.776zM67.255 11.94l5.379 4.673H61.876zm3.005 18.267h-6.01l-2.318-9.817h10.647zm0 0"
      />
      <path
        data-name="Path 11231"
        d="M36.009 59.848a1.888 1.888 0 10-1.335-.553 1.9 1.9 0 001.335.553zm0 0"
      />
    </svg>
  )
}

const MemoSvgComponent = React.memo(SvgComponent)
export default MemoSvgComponent
